<aurora-modal
        [open]="true"
        headline="New Account"
        primaryAction="Close"
        (close)="cancel.emit()"
        (keyup.enter)="$event.stopPropagation(); onInput()"
>
    <div #chatwindow class="chat-window">
        @if (chats?.length) {
            <div class="chats">
                @for (chat of chats; track chat.Id) {
                    <div class="chat" [ngClass]="{ 'request': chat.IsRequest }">
                        @if(chat.IsRequest) {
                            <div class="chat-request">
                                {{chat.RequestText}}
                            </div>
                        } @else {
                            <div class="chat-response">
                                <div>
                                    {{chat.ResponseBody.Exposition}}
                                </div>
                                @if (getCandidates(chat)?.length) {
                                    <div class="chat-response-table">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>CANDIDATE</th>
                                                    <th>CONTACT INFO</th>
                                                    <th class="table-last-column">
                                                        <aurora-button variant="tertiary" class="table-button" (click)="createNewAccount()">
                                                            Create New Account
                                                        </aurora-button>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                @for (candidate of getCandidates(chat); track candidate.AccountId) {
                                                    <tr>
                                                        <td>
                                                            <div>
                                                                <div class="d-flex">
                                                                    <div [innerHTML]="candidate.Name"></div> 
                                                                    @if(candidate.DBA) {
                                                                        &nbsp;(<div [innerHTML]="candidate.DBA"></div>)
                                                                    }
                                                                </div>
                                                                <div class="d-flex">
                                                                    @if (candidate.Address1) {
                                                                        <div [innerHTML]="candidate.Address1"></div>,&nbsp;
                                                                    }
                                                                    @if (candidate.Address2) {
                                                                        <div [innerHTML]="candidate.Address2"></div>,&nbsp;
                                                                    }
                                                                    @if (candidate.City) {
                                                                        <div [innerHTML]="candidate.City"></div>,&nbsp;
                                                                    }
                                                                    @if (candidate.State) {
                                                                        <div [innerHTML]="candidate.State"></div>&nbsp;
                                                                    }
                                                                    @if (candidate.PostalCode) {
                                                                        <div [innerHTML]="candidate.PostalCode"></div>
                                                                    }
                                                                </div>
                                                                <div>
                                                                    @if (candidate.County) {
                                                                        <div [innerHTML]="candidate.County + ' County'"></div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div [innerHTML]="'Phone: ' + candidate.Phone"></div>
                                                            @if (candidate.Website) {
                                                                <div [innerHTML]="candidate.Website"></div>
                                                            }
                                                            @if (candidate.FEIN?.includes("<strong>")) {
                                                                <div [innerHTML]="'FEIN: ' + candidate.FEIN"></div>
                                                            }
                                                        </td>
                                                        <td>
                                                            <div class="scoring-and-button">
                                                                <div>{{candidate.Confidence}}%</div>
                                                                <div>
                                                                    <aurora-link-button size="small" class="pe-1 table-button" (click)="goToAccount(candidate.AccountId)">
                                                                        Use This Account
                                                                    </aurora-link-button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>      
                                } @else {
                                    <aurora-button variant="tertiary" (click)="createNewAccount()">
                                        Create New Account
                                    </aurora-button>
                                }
                            </div>
                        }
                    </div>
                }

                @if (this.waitingForResponse) {
                    <div class="chat searching">
                        <div class="robot"><aurora-icon icon="robot-face"></aurora-icon></div>
                        <h4>Searching & Analyzing Account List...</h4>
                    </div>
                }
            </div>
        } @else {
            <div class="chat-zero">
                Let us check that your Account doesn't already exist by entering the 
                Account Information below by typing, uploading a document or telling us what it is...
            </div>
        }
    </div>
    <div class="chat-footer">
        <input class="form-control footer-input" [(ngModel)]="currentRequest" placeholder="Type Account Info..." />
        <input #fileInput type="file" style="display: none;" (change)="onFileSelected($event)" />
        <div class="footer-buttons">
            <aurora-icon-button icon="paperclip" variant="ghost" aria-label="Attach a file" (click)="fileInput.click()"></aurora-icon-button>
            <!-- <aurora-icon-button icon="megaphone" variant="ghost" aria-label="Dictate"></aurora-icon-button> -->
            <aurora-icon-button
                icon="send"
                variant="ghost"
                aria-label="Send"
                (click)="onInput()"
                [disabled]="!currentRequest && !selectedFile"></aurora-icon-button>
        </div>
    </div>
</aurora-modal>
